export default "__VITE_ASSET__Bt8hLoU1__"